import { gsap } from 'gsap'

export default class VideoModal {
  constructor(config) {
    // 準備
    this.config = config
    this.parent = this.config.parent
    this.className = this.config.className || 'videoModal_list'
    this.elm = gsap.utils.toArray(`.${this.className}`, this.parent)
    this.overlayElm
    this.videoOuter
    this.video
    this.closeBtn
    this.closeClass = 'videoModal_close'
    this.toggle = false

    console.log('this.className', this.elm)
    // 初期処理
    if (this.parent) {
      this.setOverlay()
      this.elm.forEach((elm, index) => {
        elm.addEventListener('click', (e) => this.openModal(e))
      })

      const closeElm = gsap.utils.toArray(`.${this.closeClass}`)
      closeElm.forEach((elm, index) => {
        elm.addEventListener('click', (e) => this.closeModal(e))
      })
    }
  }
  setOverlay = () => {
    let div = document.createElement('div')
    div.classList.add('videoModal_bg', 'videoModal_close')
    div.style.backgroundColor = 'rgb(36,36,36,0.95)'
    div.style.width = '100%'
    div.style.height = '100%'
    div.style.position = 'fixed'
    div.style.top = 0
    div.style.left = 0
    div.style.zIndex = 1000
    div.style.opacity = 0
    div.style.pointerEvents = 'none'
    div.style.display = 'flex'
    div.style.justifyContent = 'center'
    div.style.alignItems = 'center'
    this.overlayElm = div

    let btn = document.createElement('button')
    btn.classList.add('videoModal_close')
    btn.style.position = 'absolute'
    btn.style.top = '15px'
    btn.style.right = '15px'
    btn.style.width = '2.5em'
    btn.style.height = '2.5em'
    this.closeBtn = btn

    let videoOuter = document.createElement('div')
    videoOuter.classList.add('videoModal_content-outer')
    videoOuter.style.position = 'relative'
    this.videoOuter = videoOuter

    let video = document.createElement('video')
    video.classList.add('videoModal_content')
    video.controls = true
    video.muted = false
    video.aoutplay = false
    video.playsInline = true
    this.video = video

    this.videoOuter.appendChild(this.video)
    this.overlayElm.appendChild(this.videoOuter)
    this.overlayElm.appendChild(this.closeBtn)
    this.parent.appendChild(this.overlayElm)
  }

  // モーダルのオープン処理
  openModal = (e) => {
    e.preventDefault()
    // console.log('openModal', e)

    const target = e.target.closest(`.${this.className}`)
    const href = target.href

    if (!href.includes('.mp4'))
      return console.log('再生可能な動画が設定されていません')

    this.video.src = href
    try {
      this.video.load()
      this.video.currentTime = 0.1

      // 表示用のアニメーション
      gsap.to(this.overlayElm, {
        autoAlpha: 1,
        pointerEvents: 'all',
        duration: 0.5
      })
      this.toggle = true
    } catch (e) {
      console.log(e)
    }
  }

  // モーデルのクローズ処理
  closeModal = (e) => {
    e.preventDefault()
    if (this.toggle && e.target.classList.contains(this.closeClass)) {
      this.video.pause()
      // 非表示用のアニメーション
      gsap
        .to(this.overlayElm, {
          autoAlpha: 0,
          pointerEvents: 'none',
          duration: 0.5
        })
        .then((res) => {
          this.video.src = ''
        })
      this.toggle = false
    }
  }
}
